import React from 'react'

export const chatSteps = (hasMessages) =>
  [
    {
      target: 'body',
      title: <div className="bg-primary p-1 text-light rounded-top">Welcome!</div>,
      content: (
        <div>
          <div className="h4">
            We’re excited to bring you the new and improved Ali experience, including features like
            our headliner: the much anticipated chat history. Follow along to discover what’s new.
          </div>
        </div>
      ),
      placement: 'center',
      styles: {
        options: {
          width: 500
        }
      }
    },
    {
      target: '.new-chat',
      title: <div className="bg-primary p-1 text-light rounded-top">New chat</div>,
      content: <div className="h4">Click here to begin a fresh conversation!</div>,
      styles: {
        options: {
          width: 400
        }
      }
    },
    !hasMessages
      ? {
          target: '.prompt-cards',
          title: <div className="bg-primary p-1 text-light rounded-top">Prompt cards</div>,
          content: (
            <div className="h4">
              Discover our new, more relevant prompt cards. These provide you with templates to
              craft your perfect prompt, without needing to be a prompting expert. Simply click to
              import and customise.
            </div>
          ),
          styles: {
            options: {
              width: 500
            }
          }
        }
      : null,
    {
      target: '.chat-history',
      title: <div className="bg-primary p-1 text-light rounded-top">Chat history</div>,
      content: (
        <div className="h4">
          It’s here! Access your previous insights from the collapsible history sidebar. Pick up
          where you left off, rename or delete chats.
        </div>
      ),
      placement: 'right',
      styles: {
        options: {
          width: 500
        }
      }
    },
    {
      target: '.chat-tools',
      title: <div className="bg-primary p-1 text-light rounded-top">Input tools</div>,
      content: (
        <div className="h4">
          Your standard tools are still here - <b>Reasoning Mode</b> to emulate human reasoning for
          interpreting data and generating responses. <b>Attach</b> to query documents.
          <b> Microphone</b> to speak your queries.
        </div>
      ),
      styles: {
        options: {
          width: 600
        }
      }
    },
    {
      target: '.exit-to-centrali',
      title: <div className="bg-primary p-1 text-light rounded-top">Return to Centrali</div>,
      content: <div className="h4">Easily return to the Centrali portal by clicking here.</div>
    },
    {
      target: '.ali-help',
      title: <div className="bg-primary p-1 text-light rounded-top">Help</div>,
      content: (
        <div className="h4">
          For a quick recap, you can repeat this tour from the help section. Finally, we value your
          input! Share your thoughts, queries or request new features here. Your feedback helps us
          improve and tailor Ali to better meet your needs.
        </div>
      ),
      styles: {
        options: {
          width: 500
        }
      }
    }
  ].filter((step) => step !== null)
